import { Avatar, AvatarProps } from '@mui/material';
import { nameToAvatar } from '@razz-team/utils';
import { useMemo } from 'react';

interface AvatarCustomerProps extends AvatarProps {
  name: string | undefined;
}

export function AvatarName({ name, ...props }: AvatarCustomerProps) {
  const initials = useMemo(() => (name ? nameToAvatar(name) : ''), [name]);
  return (
    <Avatar alt={name} {...props}>
      {initials}
    </Avatar>
  );
}
